import * as React from "react";
import { useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { TarificationSessionKey } from "model/tarification-session-key.model";
import { Patient } from "model/patient.model";
import { useTranslation } from "react-i18next";
import { animated, useTransition } from "react-spring";
import ConfirmLogout from "main/Popups/ConfirmLogout";
import { closePatient } from "store/actions/patient.actions";
import { connect } from "react-redux";
import { i18nUserContext } from "config/translations/I18n";
import { User } from "model/user.model";
import { GlobalState } from "store/configure-store";
import {
  ROUTE_MEDICATION,
  ROUTE_TARIFICATION_RESUME,
  ROUTE_TIMELINE,
  ROUTE_TUTORIAL,
} from "routes.global";
import { Card, ListGroup, Modal } from "@cc/react-components";
import { TarificationApplicationSession } from "model/tarification.model";

export interface Props
  extends RouteComponentProps,
    React.HTMLAttributes<HTMLElement> {
  show: boolean;
  onHide: () => void;
}

interface StateToPropsState {
  user: User;
  patient?: Patient;
  tarificationSession: TarificationApplicationSession;
  tarificationSessionKey: TarificationSessionKey | undefined;
}

interface DispatchToPropsState {
  closePatient: () => void;
}

const HamburgerViewModal = ({
  show,
  onHide,
  user,
  patient,
  closePatient,
  history,
  tarificationSession,
  tarificationSessionKey,
}: StateToPropsState & DispatchToPropsState & Props) => {
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [t] = useTranslation("", { i18n: i18nUserContext });

  const confirmTransitions = useTransition(confirmLogout, null, {
    from: {
      opacity: 0,
      height: "100%",
      width: "100%",
      position: "absolute",
    },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const renderHamburgerMenu = () => {
    return (
      <div className="w-100 h-100 d-flex flex-column">
        <div className="flex-grow-1" onClick={onHide} />
        <section>
          <Card>
            <ListGroup>
              {patient && (
                <ListGroup.Item
                  className="text-center"
                  onClick={() => {
                    onHide();
                    closePatient();
                    history.replace("/");
                  }}
                >
                  {t("hamburgerMenu.searchPatient")}
                </ListGroup.Item>
              )}
              {patient && (
                <ListGroup.Item
                  className="text-center"
                  onClick={() => {
                    onHide();
                    history.replace(ROUTE_TIMELINE);
                  }}
                >
                  {t("hamburgerMenu.timeline")}
                </ListGroup.Item>
              )}

              {patient && (
                <ListGroup.Item
                  className="text-center"
                  onClick={() => {
                    onHide();
                    history.replace(ROUTE_MEDICATION);
                  }}
                >
                  {t("hamburgerMenu.medicationOverview")}
                </ListGroup.Item>
              )}
              {patient && (
                <ListGroup.Item
                  className="text-center"
                  onClick={() => {
                    onHide();
                    history.replace(ROUTE_TARIFICATION_RESUME);
                  }}
                >
                  {t("hamburgerMenu.tarification")}
                </ListGroup.Item>
              )}
              <ListGroup.Item
                className="text-center"
                onClick={() => {
                  onHide();
                  history.replace(ROUTE_TUTORIAL);
                }}
              >
                {t("hamburgerMenu.tutorial")}
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </section>
        <section>
          <Card>
            <ListGroup>
              <ListGroup.Item
                className="text-center font-weight-bold"
                onClick={() => setConfirmLogout(true)}
              >
                {t("hamburgerMenu.logOut")}
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </section>
      </div>
    );
  };

  return (
    <Modal show={show} onHide={onHide} size="fullscreen">
      {confirmTransitions.map(({ item, key, props }) =>
        item ? (
          <animated.div key={key} style={props}>
            <div className="h-100 w-100 d-flex flex-column align-items-center justify-content-center">
              <Card className="w-100 p-4">
                <ConfirmLogout
                  user={user}
                  patient={patient}
                  tarificationSession={tarificationSession}
                  tarificationSessionKey={tarificationSessionKey}
                  setConfirmLogout={setConfirmLogout}
                />
              </Card>
            </div>
          </animated.div>
        ) : (
          <animated.div key={key} style={props}>
            <div className="h-100 w-100 p-4">{renderHamburgerMenu()}</div>
          </animated.div>
        )
      )}
    </Modal>
  );
};

const mapStateToProps = (state: GlobalState) => {
  return {};
};

export default connect(mapStateToProps, { closePatient })(
  withRouter(HamburgerViewModal)
);
